/* Superoom - GIFT GUARD.

   Keeps the cart's gift claims honest. Two separate lies, both of which reached a real checkout.

   LIE ONE, THE ORPHANED GIFT. The free mini is two things that do not know about each other. The
   LABEL is a line property written when the kit is added and it stays on that line forever. The
   PRICE comes from an automatic BXGY rule with its own condition: a subscription, or a Power Couple,
   in the same cart. Remove the subscription and the mini is orphaned - the rule stops applying, the
   label does not, and the customer reaches checkout reading the word "free" above a real charge.

   THE ORPHAN IS NOW REMOVED, NOT BLANKED, AND THAT IS A CHANGE OF MIND. The first version stripped
   the label and left the line, which made the cart honest and still left the customer paying 25.20
   for a mini they never chose: it had been added automatically as a gift, and the moment they
   switched from a subscription to a one-time bottle it quietly became a purchase. Honest but
   unwanted is not good enough. Nobody picks a 27.99 mini by accident, so when the thing that earned
   it goes, it goes.

   THE OLD OBJECTION DOES NOT APPLY. Removal was rejected before because the plan was remove AND
   RE-ADD to get a genuinely empty properties object, which risks losing the line if the re-add
   fails. There is nothing to re-add here. A plain removal cannot half-succeed.

   ONE OWNER PER CASE, so the two modules cannot race each other. NO SUBSCRIPTION AT ALL is this
   file: the entitlement is gone, so every gift mini goes. A SUBSCRIPTION THAT EXISTS belongs to
   superoom-cart-gift.js, which knows how many minis the basket earns and which formulas are
   redundant. This file deliberately does not touch gift lines while any subscription is present.
   Breaking that boundary is how a line gets removed by one module while the other is still counting
   it, which is exactly the bug this arrangement replaced.

   LIE TWO, THE STALE SECOND CLAIM. The PDP buy box ALSO writes its own label onto the subscription
   line ("First Drop Kit mini: Lion's Mane 15ml mini") from kit_property_label. Now that the gift is
   chosen in the cart drawer, that is a second source of truth which nothing keeps in sync: swap the
   gift to Chaga in the drawer and the subscription line still announces Lion's Mane, all the way to
   checkout. The drawer owns the choice, so this legacy claim is blanked wherever it appears, and
   doing it here rather than in the buy box also heals carts that already carry it.

   HOW A CLAIM IS CLEARED, because the obvious way silently does nothing. Posting properties:{} to
   /cart/change.js returns 200 and changes nothing: an empty object reads as "no properties
   supplied", not "remove them". Each key has to be sent back with an empty string. Shopify keeps the
   key and hides any property whose value is blank, confirmed on the cart page and at checkout. The
   legacy repair is SELECTIVE - every other property is sent back untouched - because those lines are
   often legitimate gift lines whose real claim must survive.

   CLEARING PROPERTIES CANNOT BREAK THE DISCOUNT. Shopify's native BXGY matches products, variants
   and collections. It cannot read line properties, so the rule behaves identically before and after.
   If the gift ever moves to a Shopify Function discount, which CAN read properties, re-check this
   before trusting it. */
(function () {
  if (window.__superoomGiftGuard) return;
  window.__superoomGiftGuard = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var GIFT_KEY = '_first_drop_kit';
  var LEGACY_KEY = 'First Drop Kit mini';
  var timer = null;
  var busy = false;

  function isGift(item) {
    var p = item.properties;
    return !!(p && p[GIFT_KEY]);
  }

  function hasLegacy(item) {
    var p = item.properties;
    return !!(p && p[LEGACY_KEY]);
  }

  function qualifies(cart) {
    return cart.items.some(function (it) { return !!it.selling_plan_allocation; });
  }

  /* The orphan goes entirely. See the header for why this is a removal and not a blanking. */
  function removeLine(item) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 })
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  /* Blank ONLY the legacy key, sending every other property back exactly as it was. */
  function clearLegacy(item) {
    var props = {};
    var src = item.properties || {};
    Object.keys(src).forEach(function (k) { props[k] = (k === LEGACY_KEY) ? '' : src[k]; });
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  function run() {
    if (busy) return;
    busy = true;
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return null;
        var covered = qualifies(cart);
        var jobs = [];

        cart.items.forEach(function (it) {
          if (!covered && isGift(it)) { jobs.push({ mode: 'orphan' }); return; }
          if (hasLegacy(it)) jobs.push({ mode: 'legacy' });
        });
        if (!jobs.length) return null;

        /* Sequential, because every change re-keys the lines after it. The cart is re-read each time
           and the line located again rather than trusting the snapshot - a list of keys collected up
           front goes stale the moment the first change lands. */
        return jobs.reduce(function (chain, job) {
          return chain.then(function () {
            return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (fresh) {
                if (job.mode === 'orphan' && qualifies(fresh)) return null;
                var line = fresh.items.filter(function (i) {
                  return job.mode === 'orphan' ? isGift(i) : hasLegacy(i);
                })[0];
                if (!line) return null;
                return job.mode === 'orphan' ? removeLine(line) : clearLegacy(line);
              });
          });
        }, Promise.resolve()).then(function () { return true; });
      })
      .then(function (changed) {
        busy = false;
        if (!changed) return;
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
      })
      .catch(function () { busy = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 160);
  }

  function init() {
    document.addEventListener('cart:change', schedule);
    document.addEventListener('cart:refresh', schedule);
    document.documentElement.addEventListener('cart:change', schedule);
    document.documentElement.addEventListener('cart:refresh', schedule);
    run();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
